import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'psf-advocates-flow',
		path: '/p/:slug/advocates',
		component: loadable(async () => import(/* webpackChunkName: "pages/psf_advocates_flow" */ './index'), {
			exportName: 'PsfAdvocatesFlow',
			fallback: Loading,
		}),
		frame: true,
		ssr: {
			// switch this to true to enable SSR
			enabled: true,
			seo: false,
		},
	},
];
